import React, { useCallback, useContext } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import ReportContext from '@totem/components/cyberReview/CyberReportContext';
import colors from '@totem/styles/colors';
import { debounce } from '@totem/utilities/debounce';

import './cyberReport.css';

const DEBOUNCE_TIME = 500;

const styles = {
  icon: {
    color: colors.neutral.gray,
  },
};
const NameSearch = () => {
  const { input, setInput } = useContext(ReportContext);
  const handleSearch = useCallback(
    debounce(
      (name: string) => setInput({ ...input, name, page: 1 }),
      DEBOUNCE_TIME,
    ),
    [],
  );

  return (
    <div styleName="search-bar">
      <Input
        placeholder="Search Organization"
        prefix={<SearchOutlined style={styles.icon} />}
        onChange={(event) => handleSearch(event.target.value)}
      />
    </div>
  );
};

export default NameSearch;
